
import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';

const LISTADO_COLABORADORES = 'LISTADO_COLABORADORES';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const LISTADO_TIPOS = 'LISTADO_TIPOS';
const DETALLE = 'DETALLE';
const DETALLE_COLABORADOR = 'DETALLE_COLABORADOR';
const LECTURA = 'LECTURA';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let id_period = id_emp[7];
    const params = { id, id_period };
    dispatch(setLoader(true));
    api.get('/proyecto_colaborador', params).then((response) => {
        dispatch({ type: LISTADO_COLABORADORES, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar colaboradores',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listarTipoMO = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    api.get('/tipo_mano_obra', params).then((response) => {
        const tipos = [];
        response.forEach(item=>{
            tipos.push({
                value: item.id,
                label: item.descripcion
            })
        })
        dispatch({ type: LISTADO_TIPOS, listaTipoMO: tipos });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar los proyectos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const limpiarOrden = () => (dispatch) => {
    dispatch({ type: DETALLE, detalleColaborador: [] })
};


export const registroColaborador = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormColaboradorProyecto.values;
    if (data === undefined || data === null) {
        Swal.fire({
            title: 'Colaborador',
            text: 'Debe de seleccionar tipo mano de obra',
            type: 'error',
        })
    } else {
        if (data.tipo_mdo === undefined || data.tipo_mdo === null) {
            Swal.fire({
                title: 'Colaborador',
                text: 'Debe de seleccionar tipo mano de obra',
                type: 'error',
            })
        } else {
            const formData = {
                tipo: data.tipo_mdo,
                detalle: data.detalleD,
                empresa: id_emp[5]
            }
            dispatch(setLoader(true));
            api.post('/proyecto_colaborador/', formData).then(() => {
                NotificationManager.success(
                    'Colaboradores guardados correctamente',
                    'Exito',
                    3000
                );
                let ruta = `/gestion_proyecto/${id_emp[5]}/colaboradores`
                dispatch(push(ruta));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }
}

const leerDetalle = id => (dispatch) => {
    api.get(`/proyecto_colaborador_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_COLABORADOR, detalleColab: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/proyecto_colaborador/${id}`).then((response) => {
        dispatch(leerDetalle(response.tipo_mano_obra));
        dispatch(initializeForm('FormColaboradorProyecto', response));
        dispatch({ type: LECTURA, lectura: response.tipo_mano_obra });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar orden de servicio',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarColaborador = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let ruta_lista = `/gestion_proyecto/${id_emp[5]}/colaboradores`
    dispatch(push(ruta_lista));
}

export const agregarLineaNueva = () => (dispatch, getStore) => {
    const data = getStore().form.FormColaboradorProyecto.values;
    
    if (data.nombreC === undefined || data.nombreC === null || data.nombreC === '') {
        Swal.fire({
            title: 'Colaborador',
            text: 'Debe de ingresar nombre',
            type: 'error',
        })
    } else {
        if (data.sueldoC === undefined || data.sueldoC == 0.00) {
            Swal.fire({
                title: 'Colaborador',
                text: 'Debe de ingresar sueldo',
                type: 'error',
            })
        }else{
            const formData = {
                identificador: data.identificadorC ? data.identificadorC : '',
                nombre: data.nombreC,
                sueldo: data.sueldoC,
                tipo: data.tipo_mano_obra
            }
            dispatch(setLoader(true));
            api.post('/proyecto_colaborador_detalle/', formData).then((response) => {
                NotificationManager.success(
                    'Colaborador agregado correctamente',
                    'Exito',
                    3000
                );
                dispatch(leerDetalle(response.id));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }
}

const eliminarLineaNueva = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/proyecto_colaborador_detalle/${id}`).then((response) => {
        dispatch(leerDetalle(response.id));
        NotificationManager.success(
            'Colaborador borrado correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const limpiar = () => (dispatch) => {
    dispatch({ type: DETALLE, detalleColaborador: [] })
};

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormColaboradorProyecto.values;
    dispatch(initializeForm('FormColaboradorProyecto', {
        ...data,
    }));
    dispatch({ type: DETALLE, detalleColaborador: data.detalleD })
};


export const agregarLinea = () => (dispatch, getStore) => {
    const data = getStore().form.FormColaboradorProyecto.values;
    if (data === undefined || data === null) {
        Swal.fire({
            title: 'Colaborador',
            text: 'Debe de seleccionar tipo mano de obra',
            type: 'error',
        })
    } else {
        if (data.tipo_mdo === undefined || data.tipo_mdo === null || data.tipo_mdo === '') {
            Swal.fire({
                title: 'Colaborador',
                text: 'Debe de seleccionar tipo mano de obra',
                type: 'error',
            })
        } else {
            if (data.nombreC === undefined || data.nombreC === null || data.nombreC === '') {
                Swal.fire({
                    title: 'Colaborador',
                    text: 'Debe de ingresar nombre',
                    type: 'error',
                })
            } else {
                if (data.sueldoC === undefined || data.sueldoC == 0.00) {
                    Swal.fire({
                        title: 'Colaborador',
                        text: 'Debe de ingresar sueldo',
                        type: 'error',
                    })
                } else {
                    const detalleActual = data.detalleD || [];
                    let dato = detalleActual.find(item => item.nombre === data.nombreC.trim());
                    if (dato){
                        Swal.fire({
                            title: 'Colaborador',
                            text: 'Ya existe un colaborador con el mismo nombre',
                            type: 'error',
                        })  
                    }else{
                        if (data.identificadorC){
                            let datoIdentificador = detalleActual.find(item => item.identificador === data.identificadorC.trim());
                            if (datoIdentificador){
                                Swal.fire({
                                    title: 'Colaborador',
                                    text: 'Ya existe un colaborador con el mismo identificador',
                                    type: 'error',
                                })
                            }else{
                                const nuevoDetalle = [
                                    ...detalleActual,
                                    {
                                        id: Date.now(),
                                        identificador: data.identificadorC ? data.identificadorC : '',
                                        nombre: data.nombreC,
                                        sueldo: data.sueldoC,
                                    }
                                ];
                                data.identificadorC = "";
                                data.nombreC = "";
                                data.sueldoC = 0.00;
                                data.detalleD = nuevoDetalle;
    
                                NotificationManager.success(
                                    'Colaborador ingresado',
                                    'Exito',
                                    3000
                                );
                                dispatch(actualizar());
                            }
                        }else {
                            const nuevoDetalle = [
                                ...detalleActual,
                                {
                                    id: Date.now(),
                                    identificador: data.identificadorC ? data.identificadorC : '',
                                    nombre: data.nombreC,
                                    sueldo: data.sueldoC,
                                }
                            ];
                            data.identificadorC = "";
                            data.nombreC = "";
                            data.sueldoC = 0.00;
                            data.detalleD = nuevoDetalle;

                            NotificationManager.success(
                                'Colaborador ingresado',
                                'Exito',
                                3000
                            );
                            dispatch(actualizar());
                        }
                    }
                }
            }
        }
    }
}

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormColaboradorProyecto.values;
    const nuevoDetalle = data.detalleD.filter(element => element.id !== id);
    dispatch(initializeForm('FormColaboradorProyecto', {
        ...data,
        detalleD: nuevoDetalle,
    }));
    dispatch({ type: DETALLE, detalleColaborador: nuevoDetalle })
};

export const actions = {
    listar,
    registroColaborador,
    modificarColaborador,
    leer,
    limpiarOrden,
    listarTipoMO,
    getModulo,
    agregarLinea,
    limpiar,
    eliminarLinea,
    agregarLineaNueva,
    eliminarLineaNueva
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_COLABORADORES]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [DETALLE]: (state, { detalleColaborador }) => {
        return {
            ...state,
            detalleColaborador,
        };
    },
    [DETALLE_COLABORADOR]: (state, { detalleColab }) => {
        return {
            ...state,
            detalleColab,
        };
    },
    [LECTURA]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [LISTADO_TIPOS]: (state, { listaTipoMO }) => {
        return {
            ...state,
            listaTipoMO,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    detalleColaborador: [],
    detalleColab: [],
    lectura: '',
    listaTipoMO: []
};

export default handleActions(reducers, initialState)